<template>
  <div>
    <span @mouseenter="mouseEnter" @mouseleave="mouseLeave" class="log_sig"></span>
    <div v-if="popup" class="hint" style="left: 30px; top: -10px;">
      <div class="hint_text pnl_hint_sig">
        <b>Подписано </b>{{ info.date_approved.substring(0, 10)}} <b>в</b> {{ info.date_approved.substring(11, 19) }}<br>
        <br>{{ info.info_sign.certificates.name_info.T?info.info_sign.certificates.name_info.T:'Директор' }}<br>
        {{ info.info_sign.certificates.name_info.SN?(info.info_sign.certificates.name_info.SN+(info.info_sign.certificates.name_info.G?' '+info.info_sign.certificates.name_info.G:'')):info.info_sign.certificates.name_info.CN }}<br>
        <br>
        <span v-if="info.info_sign.certificates.name_info.E"><b>E-mail </b>{{ info.info_sign.certificates.name_info.E }}<br></span>
        <b>Ключ </b>{{info.info_sign.certificates.thumbprint}}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SigInfo",
  props: ["info"],

  data() {
    return {
      popup: false
    }
  },

  getData() {
    return {}
  },

  methods: {
    mouseEnter() {
      this.popup = true;
      this.$el.addEventListener('mousemove', this.mouseMove, false);
    },
    mouseLeave() {
      this.popup = false;
      // this.$el.removeEventListener('mousemove', this.mouseMove());
    },
  }

}
</script>

<style scoped>

</style>
